import { Box, Divider, Typography } from "@mui/material"
import { Project, Report } from "graphql/types"
import { useState } from "react"
import { useNavigate } from "react-router"
import { ReportAuditTrailBox } from "./ReportAuditTrailBox"
import { ReportIndexBox } from "./ReportIndexBox"
import { ReportLeftBoxFooter } from "./ReportLeftBoxFooter"
import { ReportLeftBoxHeader } from "./ReportLeftBoxHeader"

type ReportLeftBoxProps = {
  project: Project
  report: Report
  // eslint-disable-next-line no-unused-vars
  handleReportChange: (updatedReport: Report | Partial<Report>) => void
  hasUnsavedChanges?: boolean
  onSave?: () => void
  onSaveAsNewVersion?: () => void
}

export const ReportLeftBox = (props: ReportLeftBoxProps) => {
  const { project, report, handleReportChange, hasUnsavedChanges, onSave, onSaveAsNewVersion } =
    props
  const [navPoint, setNavPoint] = useState<
    "Dashboard" | "Index" | "Auftrag" | "Kunde" | "AuditTrail"
  >("Index")
  const navigate = useNavigate()

  const handleNavigation = (nav: string) => {
    switch (nav) {
      case "Dashboard":
        navigate("/dashboard/")
        break
      case "Index":
      case "AuditTrail":
      case "Auftrag":
      case "Kunde":
        setNavPoint(nav)
        break
      default:
        break
    }
  }

  const LeftBoxPage = () => {
    switch (navPoint) {
      case "Index":
        return (
          <ReportIndexBox project={project} report={report} onReportChange={handleReportChange} />
        )
      case "Auftrag":
        return <Typography variant="h5">Auftrag</Typography>
      case "Kunde":
        return <Typography variant="h5">Kunde</Typography>
      case "AuditTrail":
        return <ReportAuditTrailBox project={project} />
      default:
        return (
          <ReportIndexBox project={project} report={report} onReportChange={handleReportChange} />
        )
    }
  }

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",

        padding: 1,
      }}
    >
      <Box sx={{ flex: "0 0 auto" }}>
        <ReportLeftBoxHeader
          project={project}
          report={report}
          onNavigation={handleNavigation}
          hasUnsavedChanges={hasUnsavedChanges}
          onReportUpdate={handleReportChange}
        />
        <Divider sx={{ my: 2 }} />
      </Box>

      <Box
        sx={{
          flex: "1 1 auto",
          overflowY: "auto",
          margin: "0.5em",
        }}
      >
        <LeftBoxPage />
      </Box>
      <Box sx={{ flex: "0 0 auto" }}>
        <Divider sx={{ mt: 2 }} />
        <ReportLeftBoxFooter
          report={report}
          project={project}
          hasUnsavedChanges={hasUnsavedChanges}
          onSave={onSave}
          onSaveAsNewVersion={onSaveAsNewVersion}
        />
      </Box>
    </Box>
  )
}
